import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { BillableMetric } from 'src/features/billableMetrics/utils/types';
import { BillableMetricFormSchemaValues } from 'src/features/billableMetrics/utils/formSchema';

const RESOURCE = '/subscriptions/billable-metric/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: BillableMetricFormSchemaValues): Promise<BillableMetric> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateBillableMetric };
